import React from "react";
import "./Group295.css";

function Group295() {
  return (
    <div className="group-295">
      <div className="flex-col-20">
        <img className="rectangle" src="/img/rectangle-87@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-91@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-87@2x.png" />
      </div>
      <div className="flex-col-19">
        <img className="rectangle" src="/img/rectangle-92@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-89@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-92@2x.png" />
      </div>
      <div className="flex-col-19">
        <img className="rectangle" src="/img/rectangle-88@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-90@2x.png" />
        <img className="rectangle-2" src="/img/rectangle-88@2x.png" />
      </div>
    </div>
  );
}

export default Group295;
